import { blocks, view } from '@yola/ws-sdk';
import sentry from 'src/js/modules/analytics/sentry';

const getAnalyticsTraits = (elements, settings) => {
  const settingsId = settings.map((setting) => setting.id);
  const element = elements.find((el) => Boolean(el));

  let blockElement = null;
  try {
    const elementId = view.accessors.getLiveElementId(element);
    blockElement = blocks.accessors.getClosestBlockByElementId(elementId);
  } catch (e) {
    console.error(e);
    const instance = sentry.instance.getInstance();
    const elementsInfo = elements.reduce((acc, el, index) => {
      acc[`element-${index}`] = el ? el.outerHTML : null;
      return acc;
    }, {});

    // To debug fluent error https://yolaa.qatouch.com/v2/defects/view/p/KVRd/did/Z8nlz
    instance.captureException(e, (scope) => {
      scope.setExtras(elementsInfo);
      return scope;
    });

    return {
      blockId: null,
      blockVariationId: null,
      settingsId,
    };
  }

  const blockId = blocks.accessors.getBlockIdByElement(blockElement);
  const blockVariationId = blocks.accessors.getVariationIdByElement(blockElement);

  return {
    blockId,
    blockVariationId,
    settingsId,
  };
};

export default getAnalyticsTraits;
